module.exports = __webpack_public_path__ + "static/media/SyncMonkey_Registration_Logo.3c1ced34.png";